import { defineStore } from 'pinia';
import { axiosInstance as axios } from '../plugins/axios';
import _, { set } from 'lodash';

import { useOrderStore } from './orderStore';
import { useDiscountStore } from './discountStore';

export const useShipmentStore = defineStore('shipmentStore', {
    state: () => {
        return {
            shipment_type: 'pickup',
            shipping_type_id: null,
            pickup_location_api_id: null,

            pickup_locations: [],
            selectedPickupLocation: null,
            pickup_date: null,

            delivery_types: [],
            selectedDeliveryType: null,

            address: "",
            city: "",
            country: "",
            state: "",
            zip_code: "",

            usa_states: [
                { name: "Alabama"},
                { name: "Alaska"},
                { name: "Arizona"},
                { name: "Arkansas"},
                { name: "California"},
                { name: "Colorado"},
                { name: "Connecticut"},
                { name: "Delaware"},
                { name: "Florida"},
                { name: "Georgia"},
                { name: "Hawaii"},
                { name: "Idaho"},
                { name: "Illinois"},
                { name: "Indiana"},
                { name: "Iowa"},
                { name: "Kansas"},
                { name: "Kentucky"},
                { name: "Louisiana"},
                { name: "Maine"},
                { name: "Maryland"},
                { name: "Massachusetts"},
                { name: "Michigan"},
                { name: "Minnesota"},
                { name: "Mississippi"},
                { name: "Missouri"},
                { name: "Montana"},
                { name: "Nebraska"},
                { name: "Nevada"},
                { name: "New Hampshire"},
                { name: "New Jersey"},
                { name: "New Mexico"},
                { name: "New York"},
                { name: "North Carolina"},
                { name: "North Dakota"},
                { name: "Ohio"},
                { name: "Oklahoma"},
                { name: "Oregon"},
                { name: "Pennsylvania"},
                { name: "Rhode Island"},
                { name: "South Carolina"},
                { name: "South Dakota"},
                { name: "Tennessee"},
                { name: "Texas"},
                { name: "Utah"},
                { name: "Vermont"},
                { name: "Virginia"},
                { name: "Washington"},
                { name: "West Virginia"},
                { name: "Wisconsin"},
                { name: "Wyoming"},
            ],
        }
    },
    persist: {
        pick: ['selectedPickupLocation', 'shipment_type', 'shipping_type_id', 'pickup_location_api_id', 'pickup_date', 'selectedDeliveryType', 'address', 'city', 'country', 'state', 'zip_code']
    },
    getters: {
        locationsForDropdown: (state) => {
            let locationsData = [
                {
                    "label": "Airport Locations",
                    "value": "airport",
                    "menu": []
                },
                {
                    "label": "Other Locations",
                    "value": "other",
                    "menu": []
                },
            ];
        
            let airportLocationIds = [353, 365, 386];
        
            _.forEach(state.pickup_locations, function(location) {
                if (_.includes(airportLocationIds, location.api_pickup_location_id)) {
                    locationsData[0]["menu"].push({
                        "label": location.name,
                        "value": location.api_pickup_location_id,
                    });
                } else {
                    locationsData[1]["menu"].push({
                        "label": location.name,
                        "value": location.api_pickup_location_id,
                    });
                }
            });
        
            let disabledLocation = [
                'Miami (MIA)',
                'Atlanta (ATL)',
                'Houston (IAH)',
                'Dallas (DFW)',
                'Dulles (IAD)',
                'Boston (BOS)',
            ];
        
            _.forEach(disabledLocation, function(location) {
                locationsData[0]["menu"].push({
                    "label": location + ': coming soon',
                    "value": null,
                    "disabled": true,
                });
            });
        
            return locationsData;
        },
        deliveryTypesForDropdown: (state) => {
            return state.delivery_types.map(deliveryType => ({
                label: deliveryType.name,
                value: deliveryType.id
            }));
        },
        validationMessage: (state) => {
            let message = "";
            if (state.shipment_type === 'pickup') {
                if (!state.selectedPickupLocation && !state.selectedPickupLocation?.id) {
                    message += "Please select a pickup location.<br>";
                }
                if (!state.pickup_date) {
                    message += "Please select a pickup date.<br>";
                }
            } else if (state.shipment_type === 'delivery') {
                if (!state.selectedDeliveryType && !state.selectedDeliveryType?.id) {
                    message += "Please select a delivery type.<br>";
                }
                if (!state.address || !state.city || !state.country || !state.state || !state.zip_code) {
                    message += "Please complete the delivery address.<br>";
                }
            }
            return message;
        },
        deliveryPrice: (state) => {
            if (state.shipment_type === 'pickup') return 0;

            const orderStore = useOrderStore();
            const discountStore = useDiscountStore();

            const subtotal = orderStore.subtotalAmount;
            const discountAmount = discountStore.couponDiscountAmount;
            const totalAmount = subtotal - discountAmount;

            let price = 0;
            if (state.shipment_type === 'delivery' && state.selectedDeliveryType && state.selectedDeliveryType?.charges) {
                price = state.selectedDeliveryType.charges;
            }

            if (totalAmount >= 99 && state.selectedDeliveryType?.id === 2) {
                price = 0
            }

            return price;
        }
    },
    actions: {
        async fetchPickupLocations(payload) {
            try {
                const params = {};
                if (payload) {
                    params.query = payload.query;
                    params.limit = payload.limit;
                }
                const res = await axios.get(`/pickup/getLocations`, {
                    params: params
                });

                this.pickup_locations = res.data;

                if (!this.selectedPickupLocation) {
                    this.setDefaultPickupLocation();
                }

                return res.data;
            } catch (error) {
                console.error("Error while fetching pickup locations results:", error);
                return error;
            }
        },
        async fetchDeliveryTypes(payload) {
            try {
                const params = {};
                if (payload) {
                    params.query = payload.query;
                    params.limit = payload.limit;
                }
                const res = await axios.get(`/shipping/getTypes`, {
                    params: params
                });

                this.delivery_types = res.data;
                return this.delivery_types;
            } catch (error) {
                console.error("Error while fetching delivery types results:", error);
                return error;
            }
        },

        setPickupLocation(payload) {
            this.selectedPickupLocation = payload || null;
        },

        setDeliveryTypeForm(payload) {
            this.selectedDeliveryType = payload || null;
        },

        setDeliveryAddressForm(payload) {
            this.address = payload.address || "";
            this.city = payload.city || "";
            this.country = payload.country || "";
            this.state = payload.state || "";
            this.zip_code = payload.zip_code || "";
        },

        setShipmentType(payload) {
            this.shipment_type = payload;

            if (payload === 'pickup') {
                this.clearDeliveryData();
                
                this.setDefaultPickupLocation();
            } else if (payload === 'delivery') {
                this.clearPickupData();
            }
        },

        clearPickupData() {
            this.selectedPickupLocation = null;
            this.pickup_location_api_id = null;
            this.pickup_date = null;
        },

        clearDeliveryData() {
            this.selectedDeliveryType = null;
            this.shipping_type_id = null;
            this.address = '';
            this.country = '';
            this.city = '';
            this.state = '';
            this.zip_code = '';
        },

        setDefaultPickupLocation() {
            this.selectedPickupLocation = _.find(this.pickup_locations, function (location) {
                return location.api_pickup_location_id === 353;
            });
            this.pickup_location_api_id = this.selectedPickupLocation ? this.selectedPickupLocation.api_pickup_location_id : null;
        }
    }
});